import React from 'react'

const Footer = () => {
	return (
		<footer>
			<div className='footer-restrictor'>
				<p>Kontakt Mattilsynet</p>
				<p>Telefon: 22 40 00 00</p>
				<a href="https://www.mattilsynet.no/om_mattilsynet/kontakt_oss/">Kontakt oss</a>
			</div>
		</footer>
	)
}

export default Footer
